import PropTypes from 'prop-types';

import { Link, } from 'react-router-dom';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Modal } from '@mui/material';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

const UsersList = ({ isOpen, onClose, modalTitle, usersData = [] }) => {
    return (
        <Modal
            open={isOpen}
            onClose={onClose}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'>
            <MDBox
                sx={{
                    
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 600,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    borderRadius: '12px',
                    p: 4,
                }}>
                <MDBox display="flex" justifyContent="space-between" alignItems="center">
                    <MDTypography id="modal-modal-title" variant="h4" component="h2">
                        {modalTitle}
                    </MDTypography>
                    <IconButton onClick={onClose}>
                        <CloseIcon fontSize="large" />
                    </IconButton>
                </MDBox>
                <MDBox sx={{
                    maxHeight: 'calc(100vh - 200px)',
                    overflow: 'auto',
                }}>
                    {
                        usersData?.map((user) => (
                            <MDBox mt={1} mb={1} key={user?.userId}>
                                <MDTypography component='span'
                                    color={"info"}
                                    fontSize='medium'
                                    sx={{
                                        cursor: 'pointer',
                                        textDecoration: 'underline'
                                    }} variant='h6'
                                >
                                    <Link to={`/users/${user?.userId}`} target='_blank' rel="noopener noreferrer" >
                                        {user?.userId}
                                    </Link>
                                </MDTypography>:
                                <MDTypography component='span' sx={{ fontSize: '16px', lineHeight: '24px' }}>
                                    {` `}{user?.email}
                                </MDTypography>
                            </MDBox>
                        ))
                    }
                </MDBox>
            </MDBox>
        </Modal>
    );
};

UsersList.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    modalTitle: PropTypes.string.isRequired,
    usersData: PropTypes.array,
};

export default UsersList